import React from 'react';
import { authRoles } from 'app/auth';

export var CloudAnalyzerConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Only super admins can access cloud analyzer
	auth: authRoles.admin,
	routes: [
		{
			path: '/cloud-analyzer/:credentialId',
			component: React.lazy(function() { return import('./CloudAnalyzerInventory'); })
		},
		{
			path: '/cloud-analyzer',
			component: React.lazy(function() { return import('./CloudAnalyzer'); })
		}
	]
};
